import React from 'react'
import './SearchDocumentsPagination.css'
import { useSearchDocumentsVadIvendContext } from 'state/context/SearchDocumentsVadIvendContext'

export default function SearchDocumentsPagination() {
  const {
    filters,
    updateFilter,
    dataDocuments,
    loadingData,
    isMoreData,
    setIsMoreData,
    setLoadingData,
    getDataDocuments,
    setDataDocuments,
  } = useSearchDocumentsVadIvendContext()

  const handlePagination = async direction => {
    if (loadingData) return

    let newPageNumber

    if (direction === 'next') {
      newPageNumber = filters.pageNumber + 1
    } else {
      newPageNumber = filters.pageNumber - 1
    }

    if (newPageNumber < 1 || (direction === 'next' && !isMoreData)) return

    try {
      setLoadingData(true)
      const newData = await getDataDocuments({
        ...filters,
        pageNumber: newPageNumber,
      })

      if (newData?.Data?.length > 0) {
        setDataDocuments(newData.Data)
        updateFilter('pageNumber', newPageNumber)
        setIsMoreData(true)
      } else {
        setIsMoreData(false)
      }
    } catch (error) {
      console.error('Error en paginación:', error)
    } finally {
      setLoadingData(false)
    }
  }

  const handleChangeTableSize = event => {
    updateFilter('pageSize', +event.target.value)
  }

  return (
    <div className="pagination-container">
      <div className="common-search-footer">
        <div className="cs-footer-content">
          <p>
            Mostrando 1 a {dataDocuments?.length || 0} de {filters.pageSize}
          </p>

          <select
            data-testid="input-pagesize-invoices"
            name="changePageSize"
            id="pageSize_selector"
            onChange={handleChangeTableSize}
            value={filters.pageSize}>
            <option value={10} data-testid="pagesize-option-10">
              10
            </option>
            <option value={25} data-testid="pagesize-option-25">
              25
            </option>
            <option value={50} data-testid="pagesize-option-50">
              50
            </option>
          </select>
        </div>
      </div>

      <div className="pagination-button-container">
        <button
          data-testid="btn-prev-page-invoices"
          className="pagination-button"
          onClick={() => handlePagination('prev')}
          disabled={filters.pageNumber === 1 || loadingData}>
          Atrás
        </button>

        <span className="pagination-number">{filters.pageNumber}</span>

        <button
          data-testid="btn-next-page-invoices"
          className="pagination-button"
          onClick={() => handlePagination('next')}
          disabled={
            dataDocuments.length < filters.pageSize ||
            !isMoreData ||
            loadingData
          }>
          Siguiente
        </button>
      </div>
    </div>
  )
}
